import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-empty-details',
  templateUrl: './empty-details.component.html',
  styleUrls: ['./empty-details.component.scss'],
})
export class EmptyDetailsComponent {
  @Input() data: string | undefined;
  @Input() retry: boolean | undefined;
  @Input() retryAction: boolean | undefined;
  retryText = this.translate.instant('RETRY_TEXT');
  readonly LANG_CONST = LANG_CONST;

  constructor(private translate: TranslateService) {}
}
